import { ReactElement } from "react";

import { ICatalogue } from "../../../apis/useGetCatalogueData/types";
import { displayCentsWithDollarSign } from "../../../common/helpers/stringUtils";
import I18nText from "../../../components/I18nText/I18nText";

interface IProps {
	item: ICatalogue;
}

const ItemDescription = ({
	item: { title, title_cn, description, description_cn, price },
}: IProps): ReactElement => {
	return (
		<div className="PDPItemDescriptionContainer">
			<h1>
				<I18nText enText={title} cnText={title_cn} className="Title" />
			</h1>
			<div className="Description">
				<I18nText enText={description} cnText={description_cn} />
			</div>
			<div className="Price">{displayCentsWithDollarSign(price)}</div>
		</div>
	);
};

export default ItemDescription;
